// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmContentSwitch = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}
		
		// Default settings are set here.
		var settings = $.extend({
			active: 'content-switch__panel--active',
			button: '.content-switch__button',
			panel: '.content-switch__panel',
			wrapper: '.content-switch'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			$(document).on('click', settings.button, function () {
				$(this).closest(settings.panel).removeClass(settings.active);
				$context.find(settings.panel).not($(this).closest(settings.panel)).addClass(settings.active);
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));